/**
  * Usage: dateString | localDate:'format'
 **/
import * as moment from 'moment';
import 'moment/locale/es';

import { Pipe, PipeTransform } from '@angular/core';
// import { formatDate } from '@angular/common';
// import { TranslateService } from '../../services/translate.service';

@Pipe({
    name: 'localDate',
    standalone: true
})
export class LocaleDatePipe implements PipeTransform {

    constructor() { }

    transform(value: any, format: string, lang: string) {
        if (!value) { return ''; }
        return moment(value).locale(lang).format(format);
    }

}